module.exports = __webpack_public_path__ + "img/tag-fill.0984ea18.svg";